import { useNotify, useTranslate, useUpdate } from "ra-core";

import { trackingStatusPatch } from "./competitors";
import { opportunityStageLabelKey, trackingStatusLabelKey } from "./labels";
import { stagePatch } from "./opportunities";
import type {
  MarketCompetitor,
  MarketOpportunity,
  OpportunityStage,
  TrackingStatus,
} from "./types";

/** Optimistic quick change of a competitor's tracking status. */
export const useTrackingStatusChange = () => {
  const [update] = useUpdate<MarketCompetitor>();
  const notify = useNotify();
  const translate = useTranslate();
  return (competitor: MarketCompetitor, status: TrackingStatus) => {
    const patch = trackingStatusPatch(competitor, status);
    if (!patch) return;
    update("market_competitors", patch, {
      mutationMode: "optimistic",
      onSuccess: () =>
        notify("market.competitors.status_updated", {
          type: "success",
          messageArgs: { status: translate(trackingStatusLabelKey(status)) },
        }),
      onError: () => notify("market.competitors.error", { type: "error" }),
    });
  };
};

/** Optimistic stage move (menu or kanban drop) with a Spanish toast. */
export const useStageChange = () => {
  const [update] = useUpdate<MarketOpportunity>();
  const notify = useNotify();
  const translate = useTranslate();
  return (opportunity: MarketOpportunity, stage: OpportunityStage) => {
    const patch = stagePatch(opportunity, stage);
    if (!patch) return;
    update("market_opportunities", patch, {
      mutationMode: "optimistic",
      onSuccess: () =>
        notify("market.opportunities.moved", {
          type: "success",
          messageArgs: { stage: translate(opportunityStageLabelKey(stage)) },
        }),
      onError: () => notify("market.opportunities.error", { type: "error" }),
    });
  };
};
